import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-container">
        <div className="about-header">
          <span className="about-label">ABOUT US</span>
          <h2 className="about-title">
            From exotic sports cars to luxury sedans and SUVs, CNCCAR's Exotic Car Collection&nbsp; 
            <span className="title-sub">
            offers an exceptional selection and CNCCAR's trusted, personalised service.
            </span>
          </h2>
        </div>

        <div className="content-area">
          <div className="separator"></div>
          <div className="about-description">
            <p className="description-text">
              We provide selection of finest luxury cars to hire such as various types of Mercedes Benz, Hummer, BMW, Porsche, Alphard, Vellfire, Mini Cooper, Fortuner, Land Cruiser, and variety Toyota fine cars. It's all here to make your delightful days.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 